import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

export const BecomeIBModal: BaseModalType = ({ close }) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('IB.Why should I become an IB?')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.TitleTextBox>
          <Modal.Body.Title>{t('IB.1 Build your client base')}</Modal.Body.Title>
          <Modal.Body.Text>
            {t('IB.Recommend Tickmill to other traders or your friends')}
          </Modal.Body.Text>
        </Modal.Body.TitleTextBox>
        <Modal.Body.TitleTextBox>
          <Modal.Body.Title>{t('IB.2 Earn from trades')}</Modal.Body.Title>
          <Modal.Body.Text>
            {t(
              'IB.The more your clients trade, the bigger is your reward. The reward is calculated'
            )}
          </Modal.Body.Text>
        </Modal.Body.TitleTextBox>

        <Modal.Body.TitleTextBox>
          <Modal.Body.Title>{t('IB.3 Manage your funds')}</Modal.Body.Title>
          <Modal.Body.Text>
            {t('IB.Access and manage your funds the way you prefer')}
          </Modal.Body.Text>
        </Modal.Body.TitleTextBox>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
